import { ColumnDetails, ColumnType } from '../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { html } from 'lit';
import {
  getExclusionRuleTypeValues,
  getLabelByExclusionRuleType,
  getLabelByPermissionType,
  getPermissionValues,
} from '../../../../utils/uiSettings/deviceControl/device-control.values';
import { DeviceControlExclusionRuleItem } from '@nirvana/shared/dtos/types/policies/common';

export enum Column {
  RULE_TYPE = 1,
  EXCEPTION = 2,
  DESCRIPTION = 3,
  PERMISSION = 4,
}

export enum ColumnKeys {
  RULE_TYPE = 'ruleType',
  EXCEPTION = 'exception',
  DESCRIPTION = 'ruleName',
  PERMISSION = 'permission',
}

export const GRID_COLUMNS = [Column.RULE_TYPE, Column.EXCEPTION, Column.DESCRIPTION, Column.PERMISSION];

export const FILTERS = [
  { [ColumnKeys.RULE_TYPE]: { in: [] } },
  { [ColumnKeys.EXCEPTION]: { contains: '' } },
  { [ColumnKeys.DESCRIPTION]: { contains: '' } },
  { [ColumnKeys.PERMISSION]: { in: [] } },
];
export const PREDEFINED_FILTERS_KEYS = [
  ColumnKeys.RULE_TYPE,
  ColumnKeys.EXCEPTION,
  ColumnKeys.DESCRIPTION,
  ColumnKeys.PERMISSION,
];
export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.RULE_TYPE,
      key: ColumnKeys.RULE_TYPE,
      columnName: translateFn('Exclusion type'),
      type: ColumnType.ENUM,
      values: getExclusionRuleTypeValues(),
      removable: false,
      sortable: true,
    },
    {
      column: Column.EXCEPTION,
      key: ColumnKeys.EXCEPTION,
      columnName: translateFn('Excluded item'),
      type: ColumnType.STRING,
      removable: false,
      sortable: true,
    },
    {
      column: Column.DESCRIPTION,
      key: ColumnKeys.DESCRIPTION,
      columnName: translateFn('Description'),
      type: ColumnType.STRING,
      removable: false,
      sortable: true,
    },
    {
      column: Column.PERMISSION,
      key: ColumnKeys.PERMISSION,
      columnName: translateFn('Permission'),
      type: ColumnType.ENUM,
      values: getPermissionValues(),
      removable: false,
      sortable: true,
    },
  ];
}

export function ruleTypeRenderer(
  rowData: unknown & { item: DeviceControlExclusionRuleItem },
  columnDetails: ColumnDetails<Column, ColumnKeys>
) {
  return html`
    <span
      class="text-medium"
      style="cursor: pointer; color: var(--gz-link-primary-color); "
      @click="${() => this.onBasicEditRowButton(rowData)}"
    >
      ${getLabelByExclusionRuleType(rowData.item.ruleType)}</span
    >
  `;
}

export function permissionRenderer(
  rowData: unknown & { item: DeviceControlExclusionRuleItem },
  columnDetails: ColumnDetails<Column, ColumnKeys>
) {
  return html`<div>${getLabelByPermissionType(rowData.item.permission)}</div>`;
}
